<template>
  <v-container fluid grid-list-xl>
    <v-flex xs8 offset-xs2>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details @change="searchCarts()"></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="carts" :loading="quoteLoading" :pagination.sync="pagination" :total-items="totalCarts" :rows-per-page-items="rowsPerPageItems">
          <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.orderCode }}</td>
            <td v-if="props.item.customerID">{{ props.item.customerID.firstName }} {{ props.item.customerID.lastName}}</td>
            <td v-else>N/A</td>
            <td>${{ props.item.subTotal.toFixed(2) }}</td>
            <td>{{ new Date(props.item.date).getDate() + "/" + (new Date(props.item.date).getMonth() + 1) + "/" + new Date(props.item.date).getFullYear() }}</td>
            <td>
              <v-select @change="quoteActions" :items="[{ text: 'Edit Quote', value: { action: 'edit', id: props.item._id } },
              { text: 'Archive', value: { action: 'archive', id: props.item._id }},
              { text: 'Duplicate', value: { action: 'duplicate', id: props.item._id }},
              { text: 'Email Quote', value: { action: 'email', id: props.item._id }},
              { text: 'Download Quote', value: { action: 'pdf', id: props.item._id, orderCode: props.item.orderCode }},
              { text: 'Download Pretty Quote', value: { action: 'pretty', id: props.item._id, orderCode: props.item.orderCode }},
              { text: 'Process Order', value: { action: 'order', id: props.item._id }}]" label="Actions"></v-select>
            </td>
          </template>
          <template slot="no-data">
            {{ loadingText }}
          </template>
          <template slot="no-results">
            Your search for '{{ search }}' didn't return any results.
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

     <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import OrderService from '@/services/OrderService.js'
export default {
  name: 'carts',
  data () {
    return {
      headers: [
        { text: 'Order Code', value: 'orderCode' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'Total', value: 'total' },
        { text: 'Date', value: 'date' },
        { text: 'Actions', value: 'actions' }
      ],
      carts: [],
      snackbar: false,
      popupText: null,
      quoteLoading: false,
      search: null,
      pagination: {},
      totalCarts: 0,
      loadingText: 'Loading...',
      rowsPerPageItems: [10, 20, 30]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getCarts().then(data => {
          this.carts = data
        })
      },
      deep: true
    }
  },
  mounted () {
    this.checkForNotifications()
  },
  methods: {
    async getCarts () {
      this.quoteLoading = true

      const { sortBy, descending, page, rowsPerPage } = this.pagination

      const response = await OrderService.fetchLimitedCarts(page, rowsPerPage, this.search)

      for (var index in response.data.carts) {
        // For each quote, get the items
        const itemQuoteResponse = await OrderService.getItems(response.data.carts[index]._id)
        itemQuoteResponse.data.items.forEach(function (item) {
          response.data.carts[index].subTotal += item.total
        })

        // Add shipping, etc
        response.data.carts[index].subTotal += response.data.carts[index].shipping
        response.data.carts[index].subTotal += response.data.carts[index].install
        response.data.carts[index].subTotal += response.data.carts[index].measure
        response.data.carts[index].subTotal += response.data.carts[index].insurance
        response.data.carts[index].subTotal -= response.data.carts[index].discount
      }

      let items = response.data.carts

      if (this.pagination.sortBy) {
        items = items.sort((a, b) => {
          const sortA = a[sortBy]
          const sortB = b[sortBy]

          if (descending) {
            if (sortA < sortB) return 1
            if (sortA > sortB) return -1
            return 0
          } else {
            if (sortA < sortB) return -1
            if (sortA > sortB) return 1
            return 0
          }
        })
      }

      const totalResponse = await OrderService.countCarts(this.search)
      this.totalCarts = totalResponse.data.count

      if (this.totalCarts === 0) {
        this.loadingText = 'No Carts Found.'
      }

      this.quoteLoading = false

      return items
    },

    async searchCarts () {
      this.carts = await this.getCarts()
    },

    async archiveQuote (id) {
      await OrderService.archiveOrder(id)
      this.getCarts()
    },

    async duplicateQuote (id) {
      await OrderService.duplicateOrder(id)
      this.getCarts()
    },

    async upgradeQuote (id) {
      await OrderService.upgradeQuote(id)
      this.getCarts()
    },

    async pdfQuote (id, orderCode) {
      const response = await OrderService.getOrderQuote(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF quote generated'
      this.snackbar = true
    },

    async prettyQuote (id, orderCode) {
      const response = await OrderService.getPrettyOrderQuote(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF pretty quote generated'
      this.snackbar = true
    },

    async quoteActions (value) {
      switch (value.action) {
        case 'edit':
          this.$router.push({ path: `/carts/edit/${value.id}` })
          break
        case 'archive':
          await OrderService.updateOrderStatus(value.id, 'Archived')
          this.getCarts()
          break
        case 'duplicate':
          const duplicateResponse = await OrderService.duplicateOrder(value.id)
          if (duplicateResponse.data.success) {
            this.popupText = `Quote duplicated successfully. Quote ${duplicateResponse.data.order.orderCode} created.`
            this.snackbar = true
          }
          this.getCarts()
          break
        case 'order':
          const orderResponse = await OrderService.upgradeQuote(value.id)
          if (orderResponse.data.success) {
            this.popupText = 'Quote upgraded successfully.'
            this.snackbar = true
            this.getCarts()
          }
          break
      }
    },

    checkForNotifications () {
      if (this.$route.params.created) {
        this.popupText = `Quote '${this.$route.params.created}' created.`
        this.snackbar = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/carts/Carts.vue